<app-obsolete-grid
  [gridConfiguration]="gridConfigurationModel" 
  [rowData]="rowDataModel"></app-obsolete-grid>
